import { useMutation } from '@tanstack/react-query'

import { updatePaymentOrderRequest } from '../../service/payment'

export const useSaveDiscount = () => {
  return useMutation({
    mutationKey: ['put-discount'],
    mutationFn: updatePaymentOrderRequest,
  })
}
